function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTileWxFlood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.69 128.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128.69,
    height: 128.69,
    rx: 17.64,
    style: {
      fill: "#003173"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.09,39.75l-31.32,23a2.1,2.1,0,0,0-.87,1.7V81a2.1,2.1,0,0,0,.91,1.74l2.1,1.46a23.65,23.65,0,0,0,13.73,4.18,23.67,23.67,0,0,0,13.73-4.18L63.18,83a2.12,2.12,0,0,1,2.41,0l1.81,1.26a24.64,24.64,0,0,0,27.46,0l2-1.41a2.1,2.1,0,0,0,.91-1.74V64.48a2.12,2.12,0,0,0-.86-1.7l-31.33-23A2.12,2.12,0,0,0,63.09,39.75ZM70,71.46H58.71a2.12,2.12,0,0,1-2.12-2.12v-11a2.11,2.11,0,0,1,2.12-2.11H70a2.1,2.1,0,0,1,2.11,2.11v11A2.11,2.11,0,0,1,70,71.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.3,92.55A28.13,28.13,0,0,1,99,89.28a2.1,2.1,0,0,0-2.21,0,30,30,0,0,1-31.28,0,2.1,2.1,0,0,0-2.21,0,29.05,29.05,0,0,1-15.64,4.4A29,29,0,0,1,32,89.28a2.1,2.1,0,0,0-2.21,0,28.22,28.22,0,0,1-7.4,3.29,2.09,2.09,0,0,0-1.53,2V97a2.12,2.12,0,0,0,2.77,2,28.43,28.43,0,0,0,6.16-2.9,2.1,2.1,0,0,1,2.21,0,29.09,29.09,0,0,0,15.64,4.4,29.14,29.14,0,0,0,15.64-4.4,2.1,2.1,0,0,1,2.21,0,30,30,0,0,0,31.28,0,2.1,2.1,0,0,1,2.21,0,27.94,27.94,0,0,0,6.08,2.87,2.12,2.12,0,0,0,2.78-2V94.58A2.1,2.1,0,0,0,106.3,92.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.3,105A28.44,28.44,0,0,1,99,101.77a2.05,2.05,0,0,0-2.21,0,30,30,0,0,1-31.28,0,2.05,2.05,0,0,0-2.21,0,29.14,29.14,0,0,1-15.64,4.4A29.09,29.09,0,0,1,32,101.77a2.05,2.05,0,0,0-2.21,0,28.52,28.52,0,0,1-7.4,3.28,2.09,2.09,0,0,0-1.53,2v2.36a2.11,2.11,0,0,0,2.77,2,27.52,27.52,0,0,0,6.16-2.9,2.1,2.1,0,0,1,2.21,0A29.09,29.09,0,0,0,47.64,113a29.14,29.14,0,0,0,15.64-4.4,2.1,2.1,0,0,1,2.21,0,30,30,0,0,0,31.28,0,2.1,2.1,0,0,1,2.21,0,28.45,28.45,0,0,0,6.08,2.88,2.12,2.12,0,0,0,2.78-2v-2.35A2.11,2.11,0,0,0,106.3,105Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.81,43.89V23.43a1.89,1.89,0,0,0-1.89-1.89H85.63a1.89,1.89,0,0,0-1.89,1.89V35L65.46,21.59a1.88,1.88,0,0,0-2.23,0L22.65,51.42a2.23,2.23,0,0,0-.48,3.11L25,58.4a2.22,2.22,0,0,0,3.11.48l35.37-26a1.41,1.41,0,0,1,1.7,0l35.36,26a2.22,2.22,0,0,0,3.11-.48l2.85-3.87a2.22,2.22,0,0,0-.48-3.11Z",
    style: {
      fill: "#fff"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileWxFlood);
export default __webpack_public_path__ + "static/media/tile_WXFlood.b6f0c980d9a9355b194f116d18ec1bcc.svg";
export { ForwardRef as ReactComponent };